import { abweisen } from "./abweisung.js";

export const ANREDEN = ["Frau", "Herr", "ohne Anrede"] as const;
export type Anrede = (typeof ANREDEN)[number];

export function istAnrede(wert: unknown): wert is Anrede {
  return typeof wert === "string" && (ANREDEN as readonly string[]).includes(wert);
}

/** Pflichtangabe Anrede eines Teilnehmers: `anrede-fehlt`, `anrede-ungueltig` (TESTSPRACHE §4, revier/01, revier/04). */
export function anredePruefen(wert: unknown): Anrede {
  if (wert === undefined || wert === null || wert === "") abweisen("anrede-fehlt");
  if (!istAnrede(wert)) abweisen("anrede-ungueltig");
  return wert;
}

export const ANSPRACHFORMEN = ["Du", "Sie"] as const;
export type Ansprachform = (typeof ANSPRACHFORMEN)[number];

export function istAnsprachform(wert: unknown): wert is Ansprachform {
  return typeof wert === "string" && (ANSPRACHFORMEN as readonly string[]).includes(wert);
}

/** Ansprache = `<Anrede> <Nachname>`, ohne Anrede `<Vor- und Nachname>` (oberflaeche.md §2.3). */
export function ansprache(anrede: Anrede, name: string): string {
  if (anrede === "ohne Anrede") return name;
  const teile = name.trim().split(/\s+/);
  return `${anrede} ${teile[teile.length - 1]}`;
}
